import { conditionFormChecker, putField } from "../../../../utils/form";
import { createColumnSelect } from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import store from "../../../../store";
import {
    createFieldCheckbox,
    createFieldRadioGroup,
    createFieldSelect, createFieldTextArea
} from "../../../../components/input/template-builder/template-builder.logic";
import lodash from "lodash";
import {
    callMainObjective,
    callSubOperation
} from "../../haz-discuss/request/haz-discuss-info/haz-discuss-info.section";
import { callUserObjective } from "../../haz-license/request/request.section";
import { callHazSpecies } from "../../inform/request/inform-product/inform-product.logic";

export const callDiscussDetailSubPurpose = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", {
        group: "SUB_PURPOSE",
        where: [{ name: "value", type: "String", operator: "like", value: searchQuery }],
    }).then(items => items.filter(item => !("3" === item.key)).map(item => ({ refLookupCase: item })));

export const callChoiceByGroup = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "HAZ_DISCUSS_CHOICE", value: searchQuery });

export const callHazSubStance = ({ searchQuery, speciesKey }) => {
    const where = searchQuery ? [
        { name: "name", type: "String", operator: "like", value: searchQuery },
        { name: "refSpecies.key", type: "String", operator: "=", value: speciesKey }
    ] : [];
    return store.dispatch("resource/v1/master/hazSubStance/search", {
        criteria: {
            isDistinct: true,
            select: ["id", "name"],
            page: 0,
            size: 1000000,
            where,
            sort: [{ name: "name", type: "ASC" }]
        }
    })
        .then(page => page.data.map(item => ({ refSubStance: item })));
}

export const createColumns = () => {
    const columns = [
        createColumnSelect({
            title: () => i18n.global.t("model.hazDiscuss.refMainObjective"),
            dataIndex: "refPurpose.id",
            customRender: ({ record }) => <div>{record.refPurpose?.value}</div>,
            inputProp: () => ({ list: callMainObjective, optLabel: "value" }),
            align: "center"
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.hazDiscuss.refSubObjective"),
            dataIndexValue: ({ record }) => record?.discussCases?.filter(items => items.refLookupCase.group === "SUB_PURPOSE").map(itemName => itemName.refLookupCase?.value).join(', '),
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            sorter: false,
            search: { visible: () => false },
            align: "center"
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.hazDiscuss.refMainOperation"),
            dataIndex: "refOperation.id",
            customRender: ({ record }) => <div>{record.refOperation?.value}</div>,
            inputProp: () => ({ list: callUserObjective, optLabel: "value" }),
            align: "center"
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.hazDiscuss.refSubOperation"),
            dataIndex: "refSubOperation.id",
            customRender: ({ record }) => <div>{record.refSubOperation?.value}</div>,
            inputProp: () => ({ list: callSubOperation, optLabel: "value" }),
            align: "center"
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.hazObject.refSpecies"),
            dataIndex: "refSpecies.id",
            customRender: ({ record }) => <div>{record.refSpecies?.value}</div>,
            inputProp: () => ({ list: callHazSpecies, optLabel: "value" }),
            align: "center"
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.hazDiscussCase.refChoice"),
            dataIndex: "refChoice.id",
            customRender: ({ record }) => <div>{record.refChoice?.value}</div>,
            inputProp: () => ({ list: callChoiceByGroup, optLabel: "value" }),
            align: "center"
        }),
    ]
    return columns
}

export const createField = ({ props, data, key }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refPurpose`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.hazDiscuss.refMainObjective"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refPurpose,
                            "onUpdate:value": value => model.refPurpose = value,
                            disabled: viewOnly,
                            list: callMainObjective,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}subPurposes`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.hazDiscuss.refSubObjective"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.subPurposes,
                            "onUpdate:value": value => model.subPurposes = value,
                            disabled: viewOnly,
                            list: callDiscussDetailSubPurpose,
                            renderLabel: ({ item }) => (
                                <span>
                                    { item.refLookupCase.value }
                                </span>
                            ),
                            mode: "multiple",
                            optKey: "refLookupCase.id"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValueChildren: ({ record }) => record.refLookupCase?.value }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refOperation`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.hazDiscuss.refMainOperation"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refOperation,
                            "onUpdate:value": value => model.refOperation = value,
                            disabled: viewOnly,
                            list: callUserObjective,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refSubOperation`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.hazDiscuss.refSubOperation"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refSubOperation,
                            "onUpdate:value": value => model.refSubOperation = value,
                            disabled: viewOnly,
                            list: callSubOperation,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refSpecies`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.hazObject.refSpecies")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refSpecies,
                            "onUpdate:value": value => {
                                model.refSpecies = value;
                                model.subStances.splice(0, model.subStances.length);
                            },
                            disabled: viewOnly,
                            list: callHazSpecies,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldRadioGroup({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refChoice`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.hazDiscussCase.refChoice"),
                /*labelRender: () => "",*/
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refChoice,
                            "onUpdate:value": value => (model.refChoice = value),
                            disabled: viewOnly,
                            list: callChoiceByGroup,
                            optLabel: "value"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}subStances`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.hazSubStance.modelName")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.subStances,
                            "onUpdate:value": value => model.subStances = value,
                            disabled: viewOnly || !model.refSpecies,
                            list: ({ searchQuery }) => callHazSubStance({ searchQuery,  speciesKey: model.refSpecies?.key}),
                            renderLabel: ({ item }) => (
                                <span>
                                    { item.refSubStance.name }
                                </span>
                            ),
                            mode: "multiple",
                            optKey: "refSubStance.id"
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValueChildren: ({ record }) => record.refSubStance?.name }
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: "answer",
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.hazDiscussCase.answer"),
                inputProp: () => ({ value: modelRef.answer, disabled: viewOnly, "onUpdate:value": (value) => (modelRef.answer = value) }),
            }),
            createFieldCheckbox({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: 'isToWhom',
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.hazDiscussCase.isToWhom")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            checked: modelRef.isToWhom, disabled: viewOnly, 'onUpdate:checked': checked => modelRef.isToWhom = checked
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldCheckbox({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: 'isFact',
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.hazDiscussCase.isFact")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            checked: modelRef.isFact, disabled: viewOnly, 'onUpdate:checked': checked => modelRef.isFact = checked
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: "discussCertification",
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.hazDiscussCase.discussCertification"),
                inputProp: () => ({ value: modelRef.discussCertification, disabled: viewOnly, "onUpdate:value": (value) => (modelRef.discussCertification = value) }),
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: "toWhom",
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.hazDiscussCase.toWhom"),
                inputProp: () => ({ value: modelRef.toWhom, disabled: viewOnly, "onUpdate:value": (value) => (modelRef.toWhom = value) }),
            }),
        ]
    });
};